/**
 * Closing Terms Section - Sections 13-15: Changes, Governing Law, Contact
 */

import React from 'react';

export const ClosingTermsSection: React.FC = () => (
  <>
    <section>
      <h2 className="text-xl font-semibold mb-3">13. Changes to Terms</h2>
      <p className="text-gray-600">
        We reserve the right to modify these Terms at any time. We will notify users of any material 
        changes via email or through the Service. Your continued use after changes constitutes 
        acceptance of the new Terms.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">14. Governing Law</h2>
      <p className="text-gray-600">
        These Terms are governed by the laws of the United States and the State of California, 
        without regard to conflict of law principles.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">15. Contact Information</h2>
      <p className="text-gray-600">
        For questions about these Terms of Service, please contact us at:
      </p>
      <div className="mt-3 text-gray-600">
        <p>Email: <a href="mailto:contact-us@dinner-brain.com" className="text-[#6E9C87] hover:underline">contact-us@dinner-brain.com</a></p>
        <p>Support: <a href="mailto:contact-us@dinner-brain.com" className="text-[#6E9C87] hover:underline">contact-us@dinner-brain.com</a></p>
      </div>
    </section>
  </>
);